/* eslint-disable @typescript-eslint/no-explicit-any */
import { useIntl } from 'react-intl';
import { Col, Form, FormInstance, Row } from 'antd';
import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  RangePicker,
} from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { ExpenseIncomeFormValues } from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';
import moment from 'moment';

interface Props {
  form: FormInstance<ExpenseIncomeFormValues>;
}

function FinancialChartModalForm({ form }: Props) {
  const intl = useIntl();
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Form layout="vertical" form={form}>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            name="dates"
            label={intl.formatMessage({
              id: 'dashboard.averageTicket.modal.form.startDate.endDate',
            })}
            rules={[defaultEmptyFieldError]}
            initialValue={[moment().subtract(5, 'months'), moment()]}
          >
            <RangePicker style={{ width: '100%', height: 48 }} />
          </Form.Item>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="companiesIds"
            label={intl.formatMessage({
              id: 'dashboard.averageTicket.modal.form.companies',
            })}
          >
            <CompaniesInfiniteSelectField
              queryFilter={{ active: true }}
              mode="multiple"
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default FinancialChartModalForm;
